import { LEGAL_COMPLIANCE_UPDATED_AT_FORMATTER } from "@/features/legal/config/legal.config";

// The API always serves microsecond precision (6 fraction digits), with
// either a "Z" or a "+HH:MM" offset. `Date` only understands millisecond
// precision, so the extra digits are dropped before parsing.
const MICROSECOND_FRACTION_PATTERN = /(\.\d{3})\d+/;

export const formatLegalComplianceUpdatedAt = (version: string): string => {
  const millisecondPrecisionVersion = version.replace(MICROSECOND_FRACTION_PATTERN, "$1");
  return LEGAL_COMPLIANCE_UPDATED_AT_FORMATTER.format(new Date(millisecondPrecisionVersion));
};
